module.exports = __webpack_public_path__ + "static/media/logout.1838605f.svg";